import { startTransition } from "react";
import { PanelTitle } from "@shared/ui/PanelTitle";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { Type } from "@shared/ui/Type";
import { useNavigate } from "react-router-dom";

export function OnboardingWaitlist() {
  const navigate = useNavigate();

  const handleInviteInstitution = () => {
    startTransition(() => {
      navigate("/invite-institution");
    });
  };

  return (
    <PanelTitle
      title="You’re on the waitlist."
      description="If we’re able to accommodate you for Pollinator’s program in October of 2025, we’ll reach out via email to let you know."
      className="flex-1"
      isInverted
    >
      <div className="flex flex-col gap-2 text-center md:text-left">
        <Type variant="h4" className="text-brand-100">
          What else can you do?
        </Type>
        <Type variant="body1" className="text-brand-100">
          If a program you attended is not yet participating, ask them to add
          their alumni by joining Pollinator.
        </Type>
      </div>
      <ActionButtonsGroup
        onPrimaryClick={handleInviteInstitution}
        primaryButtonText={"Invite an institution to Pollinator"}
        theme="dark"
      />
    </PanelTitle>
  );
}

export default OnboardingWaitlist;
